(() => {
  function openCookiePreferences() {
    // A) Shopify (si existiera)
    try {
      if (window.Shopify?.customerPrivacy?.showConsentManager) {
        window.Shopify.customerPrivacy.showConsentManager();
        return true;
      }
    } catch (e) {}

    // B) Intentos comunes (por si Consentmo expone algo global)
    const fnList = [
      window.showPreferences,
      window.showPreferenceCenter,
      window.openCookiePreferences,
      window.Cookiebot?.renew,
      window.UC_UI?.showSecondLayer,
      window.OneTrust?.ToggleInfoDisplay
    ];

    for (const fn of fnList) {
      try {
        if (typeof fn === "function") {
          fn();
          return true;
        }
      } catch (e) {}
    }

    // C) Click al “reopen” real del CMP si existe en el DOM
    const selectors = [
      ".isense-reopen-widget-button",
      "[data-consentmo-reopen]",
      "[data-consentmo-open]"
    ];

    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) {
        el.click();
        return true;
      }
    }

    return false;
  }

  function bind(el) {
    if (!el || el.__stCookieBound) return;
    el.__stCookieBound = true;

    el.addEventListener("click", (e) => {
      e.preventDefault();
      openCookiePreferences();
    });
  }

  function init() {
    // Caso 1: tu link con ID
    bind(document.getElementById("stCookiePrefsLink"));

    // Caso 2: por si usas data-atributo o clase
    document
      .querySelectorAll("[data-st-cookie-prefs], .st-cookie-prefs-link")
      .forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Por si el CMP inyecta botones después
  const mo = new MutationObserver(init);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
